import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Autosuggest from '../../form/autosuggest/Autosuggest'
import Button from '../../ui/button'

import { Formik, Form, Field, FieldProps } from 'formik'

import { FolloweeItem, FollowUser } from '../../../store/member/memberTypings'
import { RootState } from '../../../store/rootReducer'
import { ProfileShort } from '../../../store/commonTypes'

import { followUser } from '../../../store/member/memberSlice'
import xorWith from 'lodash/xorWith'
import './following.sass'

const initialValues: FollowUser = {
    id: null
}

const FollowingForm: React.FunctionComponent = () => {
    const [t] = useTranslation()
    const dispatch = useDispatch()

    const { followees } = useSelector((state: RootState) => state.member)

    const followedProfiles = followees.map((item: FolloweeItem) => item.followee)

    const filterSuggestions = (suggestions: ProfileShort[]) => {
        return xorWith(suggestions, followedProfiles, (suggestion, followed) => suggestion.nick === followed.nick)
    }

    return (
        <Formik
            validateOnChange={false}
            initialValues={initialValues}
            onSubmit={(values: FollowUser, formikHelpers): void => {
                dispatch(followUser(values))
                formikHelpers.resetForm()
            }}
        >
            <Form className="form followingForm">
                <Field name="id">
                    {({ field, form }: FieldProps) => (
                        <Autosuggest
                            form={form}
                            field={field}
                            placeholder={t('Search by name')}
                            filterSuggestions={filterSuggestions}
                        />
                    )}
                </Field>
                <Button type="submit" label={t('Follow user')} />
            </Form>
        </Formik>
    )
}

export default FollowingForm
